/* @flow */
import React from 'react';
import { Container } from 'flux/utils';
import ActivityBlockedView from 'payments/components/ActivityBlockedView.jsx';
import CurrentUser from 'auth/CurrentUser';

type Props = {
  title: string,
  subtext: string,
};

type State = {
  isSignedIn: boolean,
};

class ActivityBlockedViewContainer extends React.Component {
  props: Props;
  state: State;

  static getStores() {
    return [CurrentUser];
  }

  static calculateState() {
    return {
      isSignedIn: CurrentUser.isSignedIn(),
    };
  }

  render() {
    return (
      <ActivityBlockedView
        title={this.props.title}
        subtext={this.props.subtext}
        isSignedIn={this.state.isSignedIn}
      />
    );
  }
}

export default Container.create(ActivityBlockedViewContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/payments/containers/ActivityBlockedViewContainer.jsx